import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
export function hasHeader(soughtHeader, headers) {
  soughtHeader = soughtHeader.toLowerCase();

  for (var _i = 0, _a = Object.keys(headers); _i < _a.length; _i++) {
    var headerName = _a[_i];

    if (soughtHeader === headerName.toLowerCase()) {
      return true;
    }
  }

  return false;
}